/**
 * Created by Administrator on 2018/8/3 0003.
 */

import { axiosInstance, axiosTokenInstance } from './../axios'

let userPath = {
  level1:'co',
  level2:'account'
}

// 用户接口
export async function login ( data ) {
  return axiosInstance.post(`/${userPath.level1}/${userPath.level2}/login`, data )
}
//注册接口
export async function register (data) {
  return axiosInstance.post(`/${userPath.level1}/${userPath.level2}/register`,data)
}
//邮箱验证码
export async function vertifyCode (data) {
  return axiosInstance.post(`/${userPath.level1}/${userPath.level2}/vertifyCode`,data)
}
//获取个人信息
export async function getUserInfo () {
  return axiosTokenInstance.get(`/${userPath.level1}/${userPath.level2}/getUserInfo`)
}
//修改个人信息
export async function updateUserInfo (data) {
  return axiosTokenInstance.post(`/${userPath.level1}/${userPath.level2}/updateUserInfo`,data)
}
//重置密码
export async function resetPwd(data) {
  return axiosTokenInstance.post(`/${userPath.level1}/${userPath.level2}/resetPwd`,data)
}

//忘记密码
export async function forgetPwd(data) {
  return axiosInstance.post(`/${userPath.level1}/${userPath.level2}/forgetPwd`,data)
}
//上传用户头像
export async function uploadUserIcon(data) {
  return axiosTokenInstance.post(`/${userPath.level1}/${userPath.level2}/uploadUserIcon`,data)
}

//忘记密码----验证uuid
export async function isValidUuid(data) {
  return axiosInstance.get(`/${userPath.level1}/${userPath.level2}/isValidUuid?email=${data.email}&uuid=${data.uuid}`);
}
//忘记密码----更改密码
export async function updatePwd(data) {
  return axiosInstance.post(`/${userPath.level1}/${userPath.level2}/updatePwd`,data)
}
// //上传用户头像
// export async function uploadUserIcon(data) {
//   return axiosTokenInstance.post(`/${userPath.level1}/${userPath.level2}/uploadUserIcon`,data)
// }

let goodsPath = {
  level1:'co',
  level2:'index'
}

//获取商品收藏状态
export async function getCollectGoodsState (goods_id) {
  return axiosTokenInstance.get(`/${goodsPath.level1}/${goodsPath.level2}/getCollectGoodsState/${goods_id}`)
}

//获取收藏商品信息
export async function getCollectGoods () {
  return axiosTokenInstance.get(`/${goodsPath.level1}/${goodsPath.level2}/getCollectGoods`)
}

//删除收藏商品信息
export async function delCollectGoods (data) {
  return axiosTokenInstance.post(`/${goodsPath.level1}/${goodsPath.level2}/delCollectGoods`,data)
}

//添加收藏商品信息
export async function addCollectGoods (data) {
  return axiosTokenInstance.post(`/${goodsPath.level1}/${goodsPath.level2}/addCollectGoods`,data)
}


let cartPath = {
  level1:'co',
  level2:'cart'
}
//添加到购物车
export async function addCart (data) {
  return axiosTokenInstance.post(`/${cartPath.level1}/${cartPath.level2}/addCart`,data)
}

//删除购物车
export async function deleteCart (data) {
  return axiosTokenInstance.post(`/${cartPath.level1}/${cartPath.level2}/deleteCart`,data)
}
//更改购物车
export async function updateCart (data) {
  return axiosTokenInstance.post(`/${cartPath.level1}/${cartPath.level2}/updateCart`,data)
}

//获取购物车
export async function getCart () {
  return axiosTokenInstance.get(`/${cartPath.level1}/${cartPath.level2}`)
}



// WEBPACK FOOTER //
// ./src/api/interface/users.js